import { render, staticRenderFns } from "./disclaimers.vue?vue&type=template&id=27636cd0&scoped=true"
import script from "./disclaimers.vue?vue&type=script&lang=js"
export * from "./disclaimers.vue?vue&type=script&lang=js"
import style0 from "./disclaimers.vue?vue&type=style&index=0&id=27636cd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27636cd0",
  null
  
)

export default component.exports